import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-patrol-control-detail',
  templateUrl: './patrol-control-detail.component.html',
  styleUrls: ['./patrol-control-detail.component.less']
})
export class PatrolControlDetailComponent implements OnInit {
  @Input() type: any;
  @Input() control: any = null;
  controlForm: FormGroup | undefined;
  datePickerFormat = 'yyyy/MM/dd HH:mm';
  showTimeFormat: any =  { nzFormat: 'HH:mm' };
  placeholders = [
    {
      type: 'input',
      placeholder: '默认显示值'
    },
    {
      type: 'textarea',
      placeholder: '默认显示值'
    },
    {
      type: 'inputnumber',
      placeholder: '默认显示值'
    },
    {
      type: 'checkbox',
      pattern : '^(true)$|^(false)$',
      nzErrorTip: '只能填写true或者false',
      placeholder: '默认显示值,只能填写true或者false'
    },
    {
      type: 'select',
      placeholder: '默认显示值'
    },
    {
      type: 'datepicker',
      pattern : '^\d{4}-\d{1,2}-\d{1,2}$',
      nzErrorTip: '日期格式为yyyy-mm-dd，如2021-12-20',
      placeholder: '默认显示值，yyyy-mm-dd'
    },
    {
      type: 'upload',
      placeholder: '默认显示值'
    }

  ];
  constructor(
    public fb: FormBuilder
    ) { }

  ngOnInit(): void {
    if ( this.isEmpty(this.control)){
      this.controlForm = this.fb.group({
        key: [null, [Validators.required]], // 控件键
        value: [this.type !== 'checkbox' ? null : 'false'], // 控件值
        label: [null, [Validators.required]], // 名称
        placeholder: [null], // 提示内容
        // row: [null, [Validators.required]], // 行号
        // column: [null, [Validators.required]], // 列号
        order: [null, [Validators.required]], // 序号
        format: this.type !== 'datepicker' ? [null] : [null, [Validators.required]], // 显示格式，在日期控件中使用
        unit: [null], // 控件值
        options: this.type !== 'select' ? [null] : [null, [Validators.required]] // 下拉选项
      });
    }else{
      let defaultValue = this.control.value;
      if (this.control.ptctNo === 'select' && !this.isEmpty(this.control.value)){

        defaultValue = this.getValueByList(this.control.options , this.control.value);
      }
      this.controlForm = this.fb.group({
        key: [this.control.key, [Validators.required]], // 控件键
        value: [defaultValue], // 控件值
        label: [this.control.label, [Validators.required]], // 名称
        placeholder: [this.control.placeholder], // 提示内容
        // row: [null, [Validators.required]], // 行号
        // column: [null, [Validators.required]], // 列号
        order: [this.control.order, [Validators.required]], // 序号
        format: this.type !== 'datepicker' ? [this.control.format] : [this.control.format, [Validators.required]], // 显示格式，在日期控件中使用
        unit: [this.control.unit], // 控件值
        options: this.type !== 'select' ?
        [this.concatOptions(this.control.options)] : [this.concatOptions(this.control.options), [Validators.required]] // 下拉选项
      });
    }
  }
  concatOptions(options: any){
    let  str = '';
    if (this.isEmpty(options)){
      return str;
    }
    options.forEach((option: any) => {
      str = str + option.value + ',';
    });
    if (!this.isEmpty(str) ){
      str = str.substring(0, str.length - 1 );
    }
    return str;
  }
  getControForm(){
    return this.controlForm;
  }
  getPatternByType(type: string): any{
    const ls = this.placeholders.filter((placeholder: any) => {
      return placeholder.type === type;
    });
    if ( ls.length > 0){
      return ls[0].pattern;
    }else{
      return '';
    }
  }
  getPlaceholderByType(type: string): any{
    const ls = this.placeholders.filter((placeholder: any) => {
      return placeholder.type === type;
    });
    if ( ls.length > 0){
      return ls[0].placeholder;
    }else{
      return '';
    }
  }
  getErrorTipByType(type: string): any{
    const ls = this.placeholders.filter((placeholder: any) => {
      return placeholder.type === type;
    });
    if ( ls.length > 0){
      return ls[0].nzErrorTip;
    }else{
      return '';
    }
  }
  ngFormatChange(format: any){
    this.datePickerFormat = format;
    const ls = format.split(' ');
    if ( ls.length > 1){
      this.showTimeFormat = { nzFormat: ls[1]};
    }else{
      this.showTimeFormat = false;
    }
  }
  getValueByList(list: any , value: any){
    // tslint:disable-next-line:prefer-for-of
    for ( let i = 0; i < list.length; i++){
        if ( list[i].key === value ){
          return list[i].value;
        }
    }
    return '';
  }
  isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
